import React, { useState, useEffect, useRef } from "react";
import { mediaData } from "../data/mediaData";
import config from "../data/config";
import { motion } from "framer-motion";

import {
  storyChangeAnim,
  wrapperAnim,
  wrapperAnimEnd,
  childAnim,
  childAnimEnd,
} from "../data/common";

/* comp imports */
import IgnitionButton from "./IgnitionButton";
// import EndSwitchButton from "./EndSwitchButton";
import IgnitionExploreButton from "./IgnitionExploreButton";

const SplashEndWrapper = ({
  showEndScreen,
  splashListData,
  setShowEndScreen,
  currentIndex,
  currStoryId,
  storyChangeHandler,
  exploreIn3dHandler,
  callGaHandler,
}) => {
  const [splashEndData, setSplashEndData] = useState({});
  const [splashMediaUrl, setSplashMediaUrl] = useState("");
  const [splashContent, setSplashContent] = useState([]);
  const [iAmReady, setIamReady] = useState(false);
  const [explore3D, setExplore3D] = useState(false);
  const [showFinalScreen, setShowFinalScreen] = useState(true);
  const [isInitialVideoLoaded, setIsInitialVideoLoaded] = useState(false);

  const videoRef = useRef(undefined);
  useEffect(() => {
    if (splashListData && splashListData.length) {
      let tempSplashData = [];
      tempSplashData = splashListData.filter((val) => {
        return val.splash_type === "end";
      });
      setSplashEndData(tempSplashData[0]);
    }
  }, [splashListData]);

  useEffect(() => {
    const api = setTimeout(() => {
      callGaHandler("Enter3D", "Land_on_3D_CTA_screen");
    }, 200);

    return () => clearTimeout(api);
  }, []);

  useEffect(() => {
    if (splashEndData && Object.keys(splashEndData).length) {
      setSplashMediaUrl(splashEndData.splash_media_url);
      setSplashContent(splashEndData.splash_content);
    }
  }, [splashEndData]);

  useEffect(() => {
    if (splashMediaUrl !== "") {
      videoRef.current.defaultMuted = true;
      if (showEndScreen) {
        videoRef.current.play();
        setTimeout(() => {
          // videoRef.current.pause();
          setIsInitialVideoLoaded(prev => prev ? prev : true);
        }, [3500]);
      }      
    }
  }, [splashMediaUrl]);

  // const onTouchEnd = () => {
  //   setShowEndScreen(false);
  // };

  const iAmReadyHandler = (e) => {
    let checked = e.target.checked;
    if (checked) {
      setIamReady(true);
    } else {
      setIamReady(false);
    }
  };

  // useEffect(() => {
  //   if (iAmReady) {
  //     videoRef.current.play();
  //     videoRef.current.currentTime = 4.4;
  //     setTimeout(() => {
  //       setShowFinalScreen(true);
  //     }, 1000);
  //     callGaHandler("Enter3D", "I_am_ready");
  //   }
  // }, [iAmReady]);

  const explore3DHandler = () => {
    // let checked = e.target.checked;
    // if (checked) {
    //   setExplore3D(true);
    // } else {
    //   setExplore3D(false);
    // }
    setExplore3D(prev => !prev);
    exploreIn3dHandler();
    callGaHandler("Explore_you_car_in_3D", "Last_screen");
    setTimeout(() => {
      setExplore3D(prev => !prev);
    }, 5000);
    // setTimeout(() => {
    // }, 1000);
  };

  // useEffect(() => {
  //   if (explore3D) {
  //     setTimeout(() => {
  //       exploreIn3dHandler();
  //       callGaHandler("Explore_you_car_in_3D", "Last_screen");
  //       setTimeout(() => {
  //         setExplore3D(false);
  //       }, 5000);
  //     }, 1000);
  //   }
  // }, [explore3D]);

  const closeEndScreenHandler = () => {
    // if (!iAmReady) {
    //   callGaHandler("Close", "I_am_ready");
    // } else {
    //   callGaHandler("Close", "Explore_your_car_in_3D");
    // }
    callGaHandler("Close", "Explore_your_car_in_3D");
    videoRef.current = undefined;
    setShowEndScreen(false);
    storyChangeHandler(currStoryId, false, true, currentIndex);
  };

  return (
    <motion.div
      key={currStoryId}
      className="main-swiper-wrapper main-swiper-wrapper-splash splash-wrapper-last"
      variants={storyChangeAnim}
      initial="initial"
      animate="active"
      exit="exit"
    >
      {isInitialVideoLoaded ? <div className="cross-icon">
        <img
          src={mediaData["crossIcon"]}
          alt="cross-icon"
          onClick={() => {
            closeEndScreenHandler();
          }}
        />
      </div> : null}
      <div className="splash-video-block">
        {splashMediaUrl !== "" && splashContent && splashContent.length ? (
          <>
            <video
              preload="true"
              muted
              autoPlay
              playsInline
              disablePictureInPicture
              ref={videoRef}
              poster={mediaData["videoPoster"]}
            >
              <source
                src={`${config.BUCKET_URL}${splashMediaUrl}`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>

            {isInitialVideoLoaded ? showFinalScreen ? (
              <motion.div
                className="splash-content-wrapper splash-content-end"
                variants={wrapperAnimEnd}
                initial="initial"
                animate="animate"
                key={"end"}
              >
                <motion.div
                  className="splash-text-wrapper mt-4 md:mt-[0.6rem]"
                  variants={childAnimEnd}
                >
                  <div className="splash-title">
                    {splashEndData?.splash_content[4]}
                  </div>
                  <div className="splash-small-text splash-small-text2">
                     {splashEndData?.splash_content[5]} <b>{splashEndData?.splash_content[6]}</b> {splashEndData?.splash_content[7]}
                  </div>
                  <div className="splash-smaller-text splash-smaller-text2 !mt-6">
                    {splashEndData?.splash_content[8]}
                  </div>
                </motion.div>

                <motion.div
                  className="splash-text-wrapper mb-3"
                  variants={childAnimEnd}
                >
                  {/* <EndSwitchButton exploreIn3dHandler={exploreIn3dHandler} callGaHandler={callGaHandler} isLastScreen /> */}
                  <IgnitionExploreButton
                    explore3D={explore3D}
                    explore3DHandler={explore3DHandler}
                  />
                </motion.div>
              </motion.div>
            ) : (
              <motion.div
                className="splash-content-wrapper splash-content-end"
                variants={wrapperAnim}
                initial="initial"
                animate="animate"
                key={"start"}
                exit={"exit"}
              >
                <motion.div
                  className="splash-text-wrapper mt-4"
                  variants={childAnim}
                >
                  <div className="splash-title">
                    {splashEndData?.splash_content[0]}
                  </div>
                  <div className="splash-small-text splash-small-text-mobile">
                    <b>{splashEndData?.splash_content[1]}</b> {splashEndData?.splash_content[2]}
                  </div>
                </motion.div>

                <motion.div
                  className="splash-text-wrapper mb-3"
                  variants={childAnim}
                >
                  <div className="splash-small-text">
                    {splashEndData?.splash_content[3]}
                  </div>
                  <IgnitionButton
                    iAmReady={iAmReady}
                    iAmReadyHandler={iAmReadyHandler}
                  />
                </motion.div>
              </motion.div>
            ): null}
          </>
        ) : null}
      </div>
    </motion.div>
  );
};

export default SplashEndWrapper;
